import DashboardPieChart from './DashboardPieChart';

export default DashboardPieChart;
